import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=38a340f2&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=38a340f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a340f2",
  null
  
)

export default component.exports